import React, { FunctionComponent, useContext } from "react";
import NotFound from "../pages/NotFound";
import { AccessPermissionContext } from "../../providers/AccessPermissionsProvider";

/**
 * Renders ``children`` only when ``AccessPermissionContext.hasPermissions``
 * is true. Wrap a page's body in this so its data-fetching hooks don't fire
 * for unauthorised users — the inner component is only mounted after the
 * route's feature/permission/capability check has passed.
 *
 * Usage:
 *
 *   const FooPageInner: React.FC = () => {
 *     const { data } = useFooApi();  // only runs when hasPermissions === true
 *     ...
 *   };
 *
 *   const FooPage: React.FC = () => (
 *     <AccessGuard>
 *       <FooPageInner />
 *     </AccessGuard>
 *   );
 *
 *   export default FooPage;
 */
const AccessGuard: FunctionComponent = ({ children }) => {
  const { hasPermissions } = useContext(AccessPermissionContext);
  if (!hasPermissions) {
    return <NotFound />;
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default AccessGuard;
